var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "yd-dialog",
    {
      attrs: {
        title: "新增工单",
        visible: _vm.addVisible,
        "append-to-body": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.addVisible = $event
        },
        close: _vm.closeAdd,
      },
    },
    [
      _c(
        "div",
        [
          !["6", "7", "8", "9", "10"].includes(_vm.paramForm.typeId)
            ? _c(
                "el-form",
                {
                  ref: "ruleForm",
                  staticClass: "demo-form-inline",
                  attrs: {
                    rules: _vm.rules,
                    model: _vm.paramForm,
                    size: "small",
                    "label-position": "right",
                    "label-width": "100px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "工单类型：", prop: "typeId" } },
                    [
                      _c("el-cascader", {
                        ref: "cascader",
                        staticStyle: { width: "200px" },
                        attrs: {
                          options: _vm.treeList,
                          clearable: "",
                          props: {
                            expandTrigger: "hover",
                            value: "id",
                            label: "name",
                            children: "childWorkOrderType",
                            emitPath: false,
                          },
                        },
                        on: { change: _vm.handleChange },
                        model: {
                          value: _vm.paramForm.typeId,
                          callback: function ($$v) {
                            _vm.$set(_vm.paramForm, "typeId", $$v)
                          },
                          expression: "paramForm.typeId",
                        },
                      }),
                      _vm.tips
                        ? _c(
                            "div",
                            {
                              staticClass: "font-12 color-redFont flex",
                              staticStyle: { "margin-left": "-80px" },
                            },
                            [
                              _c(
                                "div",
                                { staticStyle: { "line-height": "20px" } },
                                [_vm._v("填写说明：")]
                              ),
                              _c("div", {
                                staticClass: "richText",
                                domProps: { innerHTML: _vm._s(_vm.tips) },
                              }),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  !["6", "7"].includes(_vm.paramForm.typeId)
                    ? [
                        _vm.paramForm.typeId
                          ? _c(
                              "el-form-item",
                              {
                                attrs: { label: "工单内容：", prop: "content" },
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "400px" },
                                  attrs: {
                                    type: "textarea",
                                    clearable: "",
                                    placeholder: "请输入工单内容",
                                    maxlength: "500",
                                    "show-word-limit": "",
                                    rows: 5,
                                  },
                                  model: {
                                    value: _vm.paramForm.content,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.paramForm, "content", $$v)
                                    },
                                    expression: "paramForm.content",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.paramForm.typeId
                          ? _c(
                              "el-form-item",
                              { attrs: { label: "图片：" } },
                              [
                                _c("upload-image", {
                                  ref: "uploadImage",
                                  attrs: {
                                    code: "work-order",
                                    quality: 0.8,
                                    limit: 20,
                                  },
                                  on: { input: _vm.handleSuccess },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.paramForm.typeId
                          ? _c(
                              "el-form-item",
                              { attrs: { label: "附件：" } },
                              [
                                _c("file-upload", {
                                  attrs: {
                                    code: "work-order",
                                    list: _vm.fileList,
                                    limit: 10,
                                  },
                                  on: { input: _vm.handleFileSuccess },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.paramForm.typeId ? _c("el-divider") : _vm._e(),
                        _vm.paramForm.typeId && _vm.templateList
                          ? _c(
                              "el-form-item",
                              {
                                staticClass: "templateList",
                                attrs: { label: "下载模版：" },
                              },
                              _vm._l(_vm.templateList, function (item) {
                                return _c("div", { key: item.url }, [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "color-666 text-eli margin-right-10",
                                      staticStyle: { width: "250px" },
                                    },
                                    [_vm._v(_vm._s(item.fileName))]
                                  ),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "margin-left-10 pointer",
                                      staticStyle: { color: "#409eff" },
                                      attrs: {
                                        href: item.fileUrl,
                                        download: "",
                                      },
                                    },
                                    [_vm._v("下载")]
                                  ),
                                ])
                              }),
                              0
                            )
                          : _vm._e(),
                      ]
                    : _vm._e(),
                ],
                2
              )
            : _vm._e(),
          ["6", "7", "8", "9", "10"].includes(_vm.paramForm.typeId)
            ? _c(
                "el-form",
                {
                  ref: "ruleForm",
                  staticClass: "demo-form-inline",
                  attrs: {
                    rules: _vm.rules,
                    model: _vm.contentForm,
                    size: "small",
                    "label-position": "right",
                    "label-width": "100px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "工单类型：", prop: "typeId" } },
                    [
                      _c("el-cascader", {
                        ref: "cascader",
                        staticStyle: { width: "200px" },
                        attrs: {
                          options: _vm.treeList,
                          clearable: "",
                          props: {
                            expandTrigger: "hover",
                            value: "id",
                            label: "name",
                            children: "childWorkOrderType",
                            emitPath: false,
                          },
                        },
                        on: { change: _vm.handleChange },
                        model: {
                          value: _vm.paramForm.typeId,
                          callback: function ($$v) {
                            _vm.$set(_vm.paramForm, "typeId", $$v)
                          },
                          expression: "paramForm.typeId",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm.paramForm.typeId === "6"
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "姓名：", prop: "username" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "200px" },
                            attrs: { clearable: "", placeholder: "请输入姓名" },
                            model: {
                              value: _vm.contentForm.username,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.contentForm,
                                  "username",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "contentForm.username",
                            },
                          }),
                        ],
                        1
                      )
                    : _c(
                        "el-form-item",
                        { attrs: { label: "账号：", prop: "name" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "250px" },
                              attrs: {
                                filterable: "",
                                placeholder: "请选择部门",
                              },
                              on: { change: _vm.getUser },
                              model: {
                                value: _vm.contentForm.merchantIds,
                                callback: function ($$v) {
                                  _vm.$set(_vm.contentForm, "merchantIds", $$v)
                                },
                                expression: "contentForm.merchantIds",
                              },
                            },
                            _vm._l(_vm.merchantDic, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: {
                                  label: item.merchantName,
                                  value: item.id,
                                },
                              })
                            }),
                            1
                          ),
                          _c(
                            "el-select",
                            {
                              staticStyle: {
                                width: "150px",
                                "margin-left": "10px",
                              },
                              attrs: {
                                placeholder: "请选择对应人员",
                                filterable: "",
                              },
                              model: {
                                value: _vm.contentForm.username,
                                callback: function ($$v) {
                                  _vm.$set(_vm.contentForm, "username", $$v)
                                },
                                expression: "contentForm.username",
                              },
                            },
                            _vm._l(_vm.userList, function (item) {
                              return _c("el-option", {
                                key: item.userId,
                                attrs: {
                                  label: item.userName,
                                  value: item.userName,
                                },
                                nativeOn: {
                                  click: function ($event) {
                                    return _vm.onUserChange(item)
                                  },
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                  _vm.paramForm.typeId === "6" || _vm.userInfo.mobilePhone
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "手机号：", prop: "phone" } },
                        [
                          !_vm.phoneEdit && _vm.paramForm.typeId === "7"
                            ? _c("span", [
                                _vm._v(_vm._s(_vm.userInfo.mobilePhone)),
                              ])
                            : _c("el-input", {
                                staticStyle: { width: "200px" },
                                attrs: {
                                  clearable: "",
                                  placeholder: "请输入手机号",
                                },
                                model: {
                                  value: _vm.contentForm.phone,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.contentForm,
                                      "phone",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "contentForm.phone",
                                },
                              }),
                          _vm.paramForm.typeId === "7"
                            ? _c(
                                "el-button",
                                {
                                  staticClass: "margin-x-10",
                                  attrs: { type: "text" },
                                  on: {
                                    click: function ($event) {
                                      _vm.phoneEdit = !_vm.phoneEdit
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.phoneEdit ? "取消" : "编辑")
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.paramForm.typeId === "6" || _vm.userInfo.mobilePhone
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "所属公司：", prop: "merchantId" } },
                        [
                          !_vm.merchantEdit && _vm.paramForm.typeId === "7"
                            ? _c("span", [
                                _vm._v(_vm._s(_vm.userInfo.merchantName)),
                              ])
                            : _c(
                                "el-select",
                                {
                                  staticStyle: { width: "200px" },
                                  attrs: {
                                    filterable: "",
                                    placeholder: "请选择",
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.contentForm.merchantId,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.contentForm,
                                        "merchantId",
                                        $$v
                                      )
                                    },
                                    expression: "contentForm.merchantId",
                                  },
                                },
                                _vm._l(_vm.merchantDic, function (item) {
                                  return _c("el-option", {
                                    key: item.id,
                                    attrs: {
                                      label: item.merchantName,
                                      value: item.id,
                                    },
                                    nativeOn: {
                                      click: function ($event) {
                                        return _vm.labelClick(item.merchantName)
                                      },
                                    },
                                  })
                                }),
                                1
                              ),
                          _vm.paramForm.typeId === "7"
                            ? _c(
                                "el-button",
                                {
                                  staticClass: "margin-x-10",
                                  attrs: { type: "text" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleEdit(1)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.merchantEdit ? "取消" : "编辑")
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.paramForm.typeId === "6" || _vm.userInfo.mobilePhone
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "所属角色：", prop: "role" } },
                        [
                          !_vm.rolesEdit && _vm.paramForm.typeId === "7"
                            ? _c("span", [
                                _vm._v(_vm._s(_vm.userInfo.rolesNames || "-")),
                              ])
                            : _c(
                                "el-select",
                                {
                                  staticStyle: { width: "200px" },
                                  attrs: {
                                    placeholder: "请选择角色",
                                    filterable: "",
                                    multiple: "",
                                    clearable: "",
                                  },
                                  on: { change: _vm.roleChange },
                                  model: {
                                    value: _vm.contentForm.role,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.contentForm, "role", $$v)
                                    },
                                    expression: "contentForm.role",
                                  },
                                },
                                _vm._l(_vm.roleList, function (item) {
                                  return _c("el-option", {
                                    key: item.id,
                                    attrs: { label: item.name, value: item.id },
                                  })
                                }),
                                1
                              ),
                          _vm.paramForm.typeId === "7"
                            ? _c(
                                "el-button",
                                {
                                  staticClass: "margin-x-10",
                                  attrs: { type: "text" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleEdit(2)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.rolesEdit ? "取消" : "编辑")
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  ["8", "9", "10"].includes(_vm.paramForm.typeId)
                    ? _c(
                        "div",
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label:
                                  _vm.paramForm.typeId === "8"
                                    ? "封禁原因"
                                    : _vm.paramForm.typeId === "9"
                                    ? "解封原因"
                                    : "删除原因",
                                prop: "reason",
                              },
                            },
                            [
                              _c("el-input", {
                                staticStyle: { width: "400px" },
                                attrs: {
                                  type: "textarea",
                                  clearable: "",
                                  placeholder:
                                    "请输入" +
                                    (_vm.paramForm.typeId === "8"
                                      ? "封禁原因"
                                      : _vm.paramForm.typeId === "9"
                                      ? "解封原因"
                                      : "删除原因"),
                                  maxlength: "500",
                                  "show-word-limit": "",
                                  rows: 5,
                                },
                                model: {
                                  value: _vm.contentForm.reason,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.contentForm, "reason", $$v)
                                  },
                                  expression: "contentForm.reason",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm.paramForm.typeId === "8"
                            ? [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "封禁时间",
                                      prop: "enableTime",
                                    },
                                  },
                                  [
                                    _c("el-date-picker", {
                                      attrs: {
                                        type: "date",
                                        "value-format": "yyyy-MM-dd",
                                        "picker-options": _vm.pickerOptions,
                                        placeholder: "请选择生效日期",
                                      },
                                      model: {
                                        value: _vm.contentForm.enableTime,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.contentForm,
                                            "enableTime",
                                            $$v
                                          )
                                        },
                                        expression: "contentForm.enableTime",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            : _vm._e(),
                          _vm.paramForm.typeId === "9"
                            ? [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "解封时间",
                                      prop: "enableTime2",
                                    },
                                  },
                                  [
                                    _c("el-date-picker", {
                                      attrs: {
                                        type: "date",
                                        "value-format": "yyyy-MM-dd",
                                        "picker-options": _vm.pickerOptions,
                                        placeholder: "请选择生效日期",
                                      },
                                      model: {
                                        value: _vm.contentForm.enableTime2,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.contentForm,
                                            "enableTime2",
                                            $$v
                                          )
                                        },
                                        expression: "contentForm.enableTime2",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            : _vm._e(),
                          _vm.paramForm.typeId === "8" ||
                          _vm.paramForm.typeId === "9"
                            ? _c("el-form-item", { attrs: { label: "" } }, [
                                _c(
                                  "p",
                                  {
                                    staticStyle: {
                                      color: "#999",
                                      "font-size": "12px",
                                      margin: "-20px 0 0 0",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "若不选择生效日期，审核通过后，即刻生效"
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                        ],
                        2
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm.paramForm.typeId
        ? _c(
            "div",
            [
              _c(
                "div",
                { staticClass: "font-light margin-left-30 margin-bottom-10" },
                [_vm._v("流程：")]
              ),
              _c(
                "el-timeline",
                { staticClass: "process" },
                [
                  _c(
                    "el-timeline-item",
                    { attrs: { "hide-timestamp": "", placement: "top" } },
                    [
                      _c("div", [_vm._v("待审核")]),
                      _c("div", [
                        _vm._v(
                          "审核部门：" + _vm._s(_vm.auditDepartment || "-")
                        ),
                      ]),
                    ]
                  ),
                  _c(
                    "el-timeline-item",
                    { attrs: { "hide-timestamp": "", placement: "top" } },
                    [_vm._v(" 提交工单 ")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c("el-button", { on: { click: _vm.closeAdd } }, [_vm._v("取 消")]),
          _c(
            "el-button",
            {
              attrs: { type: "primary", disabled: !_vm.paramForm.typeId },
              on: { click: _vm.submitForm },
            },
            [_vm._v("保 存")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }